<template>
    <div class="wrapper">
     <div class="type">
        <div class="type-top">
          <div class="type-top-left"></div>
          营业执照
        </div>
        <div class="type-text">
          <div class="CodeText">
            备案号：<span> {{ RejectListProps.BLCompanyName }}</span>
          </div>
          <div class="CodeText">
            企业名称：<span>{{ RejectListProps.BLCompanyName }}</span>
          </div>
          <div class="CodeText">
            经营方式： <span>{{ RejectListProps.BLBusinessMode }}</span>
          </div>
          <div class="CodeText">
            住所： <span>{{ RejectListProps.BLAddress }}</span>
          </div>
          <div class="CodeText">
            经营场所： <span>{{ RejectListProps.BLBusinessAddr }}</span>
          </div>
          <div class="CodeText">
            库房地址： <span>{{ RejectListProps.BLWarehouseAddr }}</span>
          </div>
          <div class="CodeText">
            法定代表人： <span>{{ RejectListProps.BLLegalRepresentative }}</span>
          </div>
          <div class="CodeText">
            企业负责人： <span>{{ RejectListProps.BLCEO }}</span>
          </div>
          <div class="CodeText">
            二类经营范围： <span>{{ RejectListProps.BLSecInvSort }}</span>
          </div>
          <div class="CodeText">
            备案日期： <span>{{ RejectListProps.BLFilingDate }}</span>
          </div>
          <div class="CodeText">
            提交时间： <span>{{ RejectListProps.CreateTime }}</span>
          </div>
          <div class="CodeText">
            审核时间： <span>{{ RejectListProps.VerifyTime }}</span>
          </div>
          <div class="CodeText">
            驳回时间： <span>{{ RejectListProps.RejectTime }}</span>
          </div>
          <div class="CodeText">
            驳回原因： <span>{{ RejectListProps.RejectReason }}</span>
          </div>
          <div class="CodeText">
            营业执照：
            <div class="imgBox">
              <!-- ${ config.http_URL } + -->
              <img :src="`${RejectListProps.BLPhotoURL}`">
            </div>
            <div class="imgTopY"><img src="../../../../../assets/channel/firstbusiness/phontsD.png" alt="" class="imgPhoto" @click="imgShowClick(RejectListProps.BLPhotoURL)"></div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  export default {
    components:{},
    props:{
        RejectListProps: {
            type: Object
        }
    },
    data(){
      return {

      }
    },
    created(){},
    mounted(){},
    activated(){},
    updated(){},
    methods:{
        imgShowClick(URL) {
            this.$emit('imgShowClick',URL)
        }
    },
    computed:{},
    watch:{},
  }
</script>
<style scoped lang='less'>
@import url('../index.less');
</style>